import React, { useState, useEffect } from "react";
import {
  WhyChooseWrapper,
  WhyChooseContainer,
  WhyChooseHeader,
  WhyChooseHeaderLeft,
  // WhyChooseTitle,
  WhyChooseHeaderRight,
  WhyChooseCardsGrid,
  WhyChooseCard,
  WhyChooseCardIcon,
  WhyChooseCardTitle,
  WhyChooseCardDescription,
  WhyChooseTitleTx,
  WhyChooseSubCardsGrid,
  WhyChooseSubCardTitle,
  WhyChooseSubCard,
  WhyChooseLogo,
} from "../styles/components";
import { Box, Container, Grid, Typography, Skeleton } from "@mui/material";

const WhyToChooseSectionTx = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const mainFeatures = [
    {
      title: "No monthly base charge",
      description:
        "Designed for homes across the Lone Star State, our electricity plans are free of pesky base charges.",
      icon: "/images/landingpagev2/icons/no-base-charge.svg", // Document with X icon
    },
    {
      title: "AC Protection + Electricity Plans",
      description: "All Electricity + Protection Plans include:",
      benefits: [
        "$0 covered parts & labor*",
        "$0 trip fee",
        "$0 deductible or co-pay*",
        "Unlimited service calls",
        "Emergency service available 24/7",
        "Priority service scheduling",
      ],
      icon: "/images/landingpagev2/icons/piggy-bank.svg", // Piggy bank icon
    },
    {
      title: "Rewards & incentives",
      description:
        "We offer incentives for referring friends or family to our residential energy services. Plus, when you sign up with us, you're automatically enrolled in Constellation Rewards!",
      icon: "/images/landingpagev2/icons/rewards.svg", // Percentage sign icon
    },
    {
      title: "ETF Coverage",
      description: "We will cover your early termination fee up to $150.",
      icon: "/images/landingpagev2/icons/no_sign_fee.svg", // Document with checkmark icon
    },
  ];

  const smallFeatures = [
    {
      title: "15+ years serving Texas",
      icon: "/images/landingpagev2/icons/tx-icon.svg",
    },
    {
      title: "Up to $600/year in bill credits",
      icon: "/images/landingpagev2/icons/dollar.svg",
    },
    {
      title: "Exceptional customer service",
      icon: "/images/landingpagev2/icons/customer-support.svg",
    },
    {
      title: "Weekly usage updates & bill predictions",
      icon: "/images/landingpagev2/icons/envelope.svg",
    },
  ];

  return (
    <WhyChooseWrapper>
      <Container maxWidth="xl" sx={{ padding: { xs: "0px", md: "16px" } }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: "24px", md: "32px" },
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "24px",
              }}
            >
              <Skeleton variant="text" width="60%" height={70} />
              <Skeleton variant="text" width="80%" height={50} />
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
                gap: "32px",
              }}
            >
              {[1, 2, 3, 4].map((idx) => (
                <Skeleton
                  key={idx}
                  variant="rounded"
                  width="100%"
                  height={200}
                  sx={{ borderRadius: "16px" }}
                />
              ))}
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                },
                gap: "16px",
              }}
            >
              {[1, 2, 3, 4].map((idx) => (
                <Skeleton
                  key={idx}
                  variant="rounded"
                  width="100%"
                  height={120}
                  sx={{ borderRadius: "12px" }}
                />
              ))}
            </Box>
          </Box>
        ) : (
          <WhyChooseContainer sx={{ padding: { xs: "0px", md: "16px" } }}>
            <Box>
              <WhyChooseLogo
                src="/images/landingpagev2/short-logo.png"
                alt="logol"
              />

              <WhyChooseHeader>
                <WhyChooseHeaderLeft>
                  <WhyChooseTitleTx>
                    Great Rates.
                    <br />
                    No Hidden Fees.
                    <br />
                    Free AC Repair with Some Plans.
                    <br />
                  </WhyChooseTitleTx>
                </WhyChooseHeaderLeft>
                <WhyChooseHeaderRight>
                  We're America's largest electricity producer, and we're here to help you save money.
                  As a Constellation customer, you'll receive benefits including
                  competitive pricing, weekly bill prediction emails, access to
                  our Rewards program, and no monthly base charges. With
                  Constellation, you can expect more and get more from your
                  electricity provider.
                </WhyChooseHeaderRight>
              </WhyChooseHeader>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "16px", md: "24px" } }}>
              <WhyChooseCardsGrid>
                {mainFeatures.map((feature, index) => (
                  <WhyChooseCard key={`card-${index}`}>
                    <Box sx={{ gap: "24px" }}>
                      <WhyChooseCardIcon
                        src={feature.icon}
                        alt={feature.title}
                      />
                      <WhyChooseCardTitle>{feature.title}</WhyChooseCardTitle>
                    </Box>
                    {feature?.description && (
                      <WhyChooseCardDescription>
                        {feature?.description}
                      </WhyChooseCardDescription>
                    )}
                    {"benefits" in feature && feature.benefits && (
                      <Box
                        component="ul"
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                          columnGap: { xs: "12px", md: "24px" },
                          rowGap: "4px",
                          margin: "8px 0 0",
                          paddingLeft: "20px",
                          color: "#576367",
                          fontFamily: "Inter, sans-serif",
                          fontSize: { xs: "16px", md: "17px" },
                          fontWeight: 400,
                          lineHeight: 1.35,
                          listStylePosition: "outside",
                        }}
                      >
                        {feature.benefits.map((benefit) => (
                          <li key={benefit}>{benefit}</li>
                        ))}
                      </Box>
                    )}
                  </WhyChooseCard>
                ))}
              </WhyChooseCardsGrid>

              <WhyChooseSubCardsGrid>
                {smallFeatures.map((feature, index) => (
                  <WhyChooseSubCard key={`card-${index}`}>
                    <WhyChooseCardIcon src={feature.icon} alt={feature.title} />
                    <WhyChooseSubCardTitle>
                      {feature.title}
                    </WhyChooseSubCardTitle>
                  </WhyChooseSubCard>
                ))}
              </WhyChooseSubCardsGrid>
            </Box>
          </WhyChooseContainer>
        )}
      </Container>
    </WhyChooseWrapper>
  );
};

export default WhyToChooseSectionTx;
